import React, { useState } from "react";
import "./projects-page.css";
import UnderContruction from "../../components/under-construction/UnderContruction";
import { Container } from "react-bootstrap";
import PageHeader from "../../components/page-header/PageHeader";

const projectTitles = [
  { id: 1, title: "Lorem ipsum", desc: "lorem ipsum dolor siet amet" },
  { id: 2, title: "Lorem ipsum", desc: "lorem ipsum dolor siet amet" },
  { id: 3, title: "Lorem ipsum", desc: "lorem ipsum dolor siet amet" },
  { id: 4, title: "Lorem ipsum", desc: "lorem ipsum dolor siet amet" },
  { id: 5, title: "Lorem ipsum", desc: "lorem ipsum dolor siet amet" },
  { id: 6, title: "Lorem ipsum", desc: "lorem ipsum dolor siet amet" },
  { id: 7, title: "Lorem ipsum", desc: "lorem ipsum dolor siet amet" },
  { id: 8, title: "Lorem ipsum", desc: "lorem ipsum dolor siet amet" },
];

const ProjectsPage = () => {
  const [pageStatus, setPagestatus] = useState(false);
  return pageStatus ? (
    <div>
      <Container>
        <PageHeader title="All Projects" />
        <div className="projects-page-grid">
          {projectTitles.map((project) => (
            <ProjectDisplayCard
              title={project.title}
              desc={project.desc}
              key={project.id}
            />
          ))}
        </div>
      </Container>
    </div>
  ) : (
    <UnderContruction />
  );
};

const ProjectDisplayCard = ({ title, desc }) => {
  return (
    <div className="project-display-card">
      <div className="project-display-card-image-container"></div>
      <div className="project-display-card-title">
        <h2>
          <strong>{title}</strong> - {desc}
        </h2>
      </div>
    </div>
  );
};

export default ProjectsPage;
